import { styled } from '@mui/material/styles';

interface DrawerContainerProps {
  open: boolean;
}

interface OverlayProps {
  open: boolean;
}

const DRAWER_WIDTH = '320px';

export const DrawerContainer = styled('div')<DrawerContainerProps>`
  width: ${DRAWER_WIDTH};
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.palette.primary.main};
  z-index: ${(props) => props.theme.zIndex.drawer + 2};
  transform: ${(props) => !props.open && `translateX(-${DRAWER_WIDTH})`};
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  overflow-y: auto;
  color: ${(props) => props.theme.palette.primary.contrastText};

  @media print {
    display: none;
  }
`;

export const DrawerContent = styled('div')``;

export const Overlay = styled('div')<OverlayProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${(props) => props.theme.zIndex.drawer + 1};
  display: ${(props) => (props.open ? 'block' : 'none')};
`;
